<template>
  <div class="grid">
    <div
      class="mobile-menu-overlay"
      :class="{ 'active': this.$store.state.showMenu }"
      @click="closeMenu"
      v-if="currentUser"
    ></div>
    <div class="aside" :class="{ 'hide-tablet-landscape': !this.$store.state.showMenu}" v-if="currentUser">
      <Aside/>
    </div>
    <div class="main_dashboard">
      <div class="container">
        <div class="row" v-if="currentUser"><Header/></div>
        <div class="row"><Content/></div>

      </div>

    </div>
  </div>
  <span
      class="scrollToTop"
      @click="scrollToTop"
      v-show="showScrollButton"
  >^</span>
</template>

<script>
import Header from "@/components/Header.vue";
import Aside from "@/components/Aside.vue";
import Content from "@/components/Content.vue";

export default {
  data() {
    return {
      showScrollButton: false,
      title: "Дашборд",
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  components: {
    Header, Aside, Content
  },
  //
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showMenu() {
      return this.$store.state.showMenu;
    }
  },
  watch: {
    showMenu(newVal) {
      if (window.innerWidth <= 768) {
        if (newVal) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  created() {
    // this.$store.dispatch("fetchCompanies");
    // this.$store.dispatch("fetchChecklists");
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 50
    },
    closeMenu() {
      if (this.$store.state.showMenu) {
        this.$store.dispatch('toggleShowMenu');
      }
    }
  }
}
</script>

<style scoped>
</style>
